import validate from "/app/node_modules/.pnpm/nuxt@4.3.0_@parcel+watcher@2.5.6_@types+node@25.2.0_@vue+compiler-sfc@3.5.27_cac@6.7.14_0eb130ae073bbae7b7ba124eb928cdb6/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45config_45global from "/app/packages/website-builder/app/middleware/01.config.global.ts";
import _02_45redirect_45global from "/app/packages/website-builder/app/middleware/02.redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.3.0_@parcel+watcher@2.5.6_@types+node@25.2.0_@vue+compiler-sfc@3.5.27_cac@6.7.14_0eb130ae073bbae7b7ba124eb928cdb6/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45config_45global,
  _02_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}